var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAndroidLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_635_7598)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.4525 7.92346H6.03199C5.7557 7.92346 5.53174 8.14299 5.53174 8.41382V18.6235C5.53174 18.8943 5.7557 19.1138 6.03199 19.1138H8.24628V22.5545C8.24628 23.3528 8.90648 24 9.72095 24C10.5354 24 11.1956 23.3529 11.1956 22.5545V19.1138H13.2582V22.5545C13.2582 23.3528 13.9184 24 14.7329 24C15.5473 24 16.2076 23.3529 16.2076 22.5545V19.1138H18.4526C18.7289 19.1138 18.9529 18.8943 18.9529 18.6235V8.41382C18.9528 8.14299 18.7288 7.92346 18.4525 7.92346Z",
    fill: "#AAC148"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.42902 7.92114C2.61461 7.92114 1.95435 8.56829 1.95435 9.36665V15.2377C1.95435 16.036 2.61455 16.6832 3.42902 16.6832C4.24343 16.6832 4.90369 16.0361 4.90369 15.2377V9.36665C4.90363 8.56835 4.24343 7.92114 3.42902 7.92114Z",
    fill: "#AAC148"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.0557 7.92114C20.2413 7.92114 19.5811 8.56829 19.5811 9.36665V15.2377C19.5811 16.036 20.2413 16.6832 21.0557 16.6832C21.8701 16.6832 22.5304 16.0361 22.5304 15.2377V9.36665C22.5304 8.56835 21.8702 7.92114 21.0557 7.92114Z",
    fill: "#AAC148"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.13285 7.20745H18.323C18.6411 7.20745 18.8782 6.9203 18.8129 6.6152C18.4097 4.73139 17.1861 3.14384 15.5258 2.22674L16.5679 0.383656C16.6385 0.258874 16.5925 0.101618 16.4652 0.0324888C16.3376 -0.0368151 16.1774 0.00843866 16.1069 0.133221L15.0569 1.99019C14.1969 1.599 13.2385 1.38052 12.2279 1.38052C11.2174 1.38052 10.2589 1.599 9.39896 1.99019L8.34898 0.133162C8.27839 0.00832248 8.11797 -0.0366989 7.99073 0.0324307C7.86343 0.10156 7.81744 0.258816 7.88796 0.383597L8.93006 2.22669C7.26978 3.14384 6.0462 4.73133 5.64297 6.6152C5.5776 6.9203 5.81478 7.20745 6.13285 7.20745ZM15.8654 4.46068C15.8654 4.76752 15.6116 5.01633 15.2985 5.01633C14.9855 5.01633 14.7316 4.76758 14.7316 4.46068C14.7316 4.15383 14.9854 3.90503 15.2985 3.90503C15.6116 3.90503 15.8654 4.15383 15.8654 4.46068ZM9.15728 3.90503C9.47032 3.90503 9.72415 4.15378 9.72415 4.46068C9.72415 4.76752 9.47038 5.01633 9.15728 5.01633C8.84425 5.01633 8.59042 4.76758 8.59042 4.46068C8.59042 4.15383 8.84419 3.90503 9.15728 3.90503Z",
    fill: "#AAC148"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_635_7598"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24.4843,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAndroidLogo);
export default __webpack_public_path__ + "static/media/android-logo.dbf36466.svg";
export { ForwardRef as ReactComponent };